import isNumber from 'lodash/isNumber';

const getNumOrZero = num => (isNumber(num) ? num : 0);

export default getNumOrZero;
